import Cookies from 'js-cookie';

import { localStorageNames } from '@shared/constants/local-storage-names';
import { useAuthStore } from '@src/core/store/auth-store';

export const deleteCredentials = () => {
  useAuthStore.getState().clearAccessToken();
  Cookies.remove(localStorageNames.refreshToken);
};
